export default __webpack_public_path__ + "static/media/logo.eca70c51.svg";